import { FC } from 'react';

import classes from './Heading2.module.css';

const Heading2: FC = ({ children }) => {
  return <div className={classes.root}>{children}</div>;
};

export default Heading2;
